import { LocalStorageKeys } from "@shared/types/localTypes/storage";
import window from "@shared/utils/app-window";
import { stringLocalStorage } from "@shared/module-transformers/localStorage.ts";

const expireInHours = 24;
const marketoCookieName = "_mkto_trk";

let marketoCookie: string;

export const cookiesService = {
  getExpiration: () => {
    const now = new Date();
    now.setTime(now.getTime() + expireInHours * 3600 * 1000);
    return now;
  },

  setFromCookie: async (fromQuery?: string) => {
    const existingFrom = await stringLocalStorage.get(
      LocalStorageKeys.FROM_QUERY,
    );
    if (existingFrom) {
      return;
    }

    fromQuery = fromQuery || extractFromQueryFromUrl();
    if (!fromQuery) {
      return;
    }

    await stringLocalStorage.set(LocalStorageKeys.FROM_QUERY, fromQuery);
  },

  marketoCookie: (): string | undefined => {
    if (marketoCookie) {
      return marketoCookie;
    }

    const cookies = document.cookie.split("; ");

    const prefix = `${marketoCookieName}=`;

    for (const cookieStr of cookies) {
      if (cookieStr.startsWith(prefix)) {
        marketoCookie = cookieStr.substring(prefix.length);

        return marketoCookie;
      }
    }
  },
};

const extractFromQueryFromUrl = () => {
  const pathname = window.location.pathname;
  const pathsToSkip = ["/login", "/sso-login", "/sso-login-failed"];

  for (let i = 0; i < pathsToSkip.length; i++) {
    if (pathname.startsWith(pathsToSkip[i])) {
      return;
    }
  }
  return pathname + window.location.search;
};
